module.exports = __webpack_public_path__ + "img/icon_6.97b3c559.png";